import React from 'react';
import PropTypes from 'prop-types';
import ReactQuill from 'react-quill';

import { ExpandableList } from 'components';
import 'react-quill/dist/quill.bubble.css';

export const Message = ({ id, title, content, type, expanded, onToggleExpand }) => (
    <ExpandableList id={id} title={title} expanded={expanded} onToggleExpand={onToggleExpand}>
        {type === 'html' ? (
            <iframe
                title={title}
                srcDoc={content}
                style={{ width: '100%', border: 'none', minHeight: '400px' }}
                onLoad={e => {
                    const iframe = e.target;
                    iframe.style.height = `${iframe.contentWindow.document.body.scrollHeight}px`;
                }}
            />
        ) : (
            <ReactQuill value={content} readOnly theme="bubble" />
        )}
    </ExpandableList>
);

Message.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    expanded: PropTypes.bool,
    onToggleExpand: PropTypes.func,
};

export default Message;
